import type { SVGProps } from 'react';

const SvgStatistics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M19 17H5V6c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55.45 1 1 1h15c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M20.71 6.29a.996.996 0 0 0-1.41 0l-3.49 3.49-3.36-1.68a.99.99 0 0 0-1.15.19l-4 4a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3.49-3.49 3.36 1.68c.39.19.85.12 1.15-.19l4-4a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgStatistics;
